export default __webpack_public_path__ + "static/media/avant-logo-short.aee0bd8c.svg";